import React from 'react';
import styled from 'styled-components';

import EmailFillIcon from '@ad-scripts/presentation/components/common/icons/fill/email-fill';
import EmptyPageLayout from 'src/presentation/components/pages/shared/EmptyPageLayout';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { H2 } from '@ad-scripts/presentation/components/common/headers';
import { Section } from 'src/presentation/components/forms/Layout';
import SpinnerTwo from '@ad-scripts/presentation/components/common/spinner_two';
import theme from '@ad-scripts/presentation/themes/default';
import { useAddEmailDomain } from 'src/presentation/components/pages/email/hooks/useAddEmailDomain';

const EmailSetupEmptyPage = ({ errors, onCreate }): JSX.Element => {
  const { onEmailDomainSave, renderEmailDomainForm, isLoading } = useAddEmailDomain({
    errors,
    onSaveSuccess: onCreate,
  });

  return (
    <EmptyPageLayout data-aid="empty-domain-page">
      <StyledEmailFillIcon />
      <H2>Add a sending domain to get started with email</H2>
      <EmptyPageDescription>
        Enter a sending domain you want to use to send and receive emails in Gladly. Once you save a sending domain, it
        cannot be changed.
      </EmptyPageDescription>

      <Section>{renderEmailDomainForm()}</Section>

      <StyledButton
        type={Button.Types.PRIMARY}
        onClick={onEmailDomainSave}
        data-aid="save-and-continue-button"
        disabled={isLoading}
        loading={isLoading}
      >
        {isLoading ? <SpinnerTwo color={theme.colors.gray400} size={16} stroke={1} /> : 'Save and continue'}
      </StyledButton>
    </EmptyPageLayout>
  );
};

const StyledEmailFillIcon = styled(EmailFillIcon)`
  fill: ${({ theme }) => theme.colors.gray600};
  margin-bottom: 20px;
  width: 40px;
`;

const EmptyPageDescription = styled.div`
  margin-bottom: 24px;
  max-width: 460px;
  text-align: center;
`;

const StyledButton = styled(Button)`
  min-width: 140px;
`;

export default EmailSetupEmptyPage;
